import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'lib-ngx-bootstrap-confirm',
  templateUrl: 'ngx-bootstrap-confirm.component.html',
  styleUrls: ['ngx-bootstrap-confirm.component.scss']
})

export class NgxBootstrapConfirmComponent implements OnInit {
  public onClose: Subject<boolean>;
  title: string;
  headerLabel: string;
  confirmLabel: string;
  declineLabel: string;
  constructor(public bsModalRef: BsModalRef) {
  }

  public ngOnInit(): void {
    this.onClose = new Subject();
  }

  confirm() {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  decline() {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }
}
